/** @jsx jsx */
// import React from 'react'
import { Link } from '@reach/router'
import { jsx, Box, Text, Heading } from 'theme-ui'
import qs from 'query-string'

const drills = [
  {
    title: 'Pivot/Roll/Coil Drill #1 (Brush Knee)',
    params: qs.stringify({ url: 'https://youtu.be/D6yulo1FwUY' }),
  },
  {
    title: 'Pivot/Roll/Coil Drill #2 (Wave Hands)',
    params: qs.stringify({ url: 'https://youtu.be/-Io1A_SbQTI' }),
  },
  {
    title: 'Essential Form',
    params: qs.stringify({ url: 'https://youtu.be/ESmo4-vKPsg' }),
  },
]

const HomeScreen = () => {
  return (
    <Box sx={styles.page}>
      <Box sx={styles.container}>
        <Heading sx={styles.header}>Taiji Drills Video Practice</Heading>
        <Text sx={styles.text}>Choose one of the drills below.</Text>
        <Text sx={styles.text}>
          On the next page, use the bookmarks to the right of the video to set
          the video's starting and ending point if you want the video to repeat
          only a certain set of moves.
        </Text>
        {drills.map((drill) => (
          <Link
            key={drill.params}
            sx={styles.link}
            to={`/video?${drill.params}`}
          >
            {drill.title}
          </Link>
        ))}
      </Box>
    </Box>
  )
}

const styles = {
  page: {
    width: '100%',
    maxWidth: '72rem',
    height: '100%',
    margin: '0 auto',
  },
  container: {
    marginTop: '2rem',
    paddingY: '2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '6px',
    bg: 'white',
  },
  header: {
    mb: '1rem',
  },
  text: {
    width: '70%',
    mb: '1.5rem',
  },
  link: {
    width: '50%',
    textAlign: 'center',
    p: '2rem',
    mb: '1rem',
    bg: '#eeeeee',
    color: 'black',
    textDecoration: 'none',
    boxShadow: `1px 1px 2px 0px rgba(0,0,0,0.75)`,
    '&:hover,&:focus': {
      textDecoration: 'underline',
      boxShadow: `2px 2px 5px 0px rgba(0,0,0,0.75)`,
    },
  },
}
export default HomeScreen
